var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-google-login"},[_c('button',{staticClass:"btn",style:(_vm.buttonStyle),attrs:{"type":"button"}},[_c('div',{staticClass:"d-flex flex-row align-item-center"},[_c('IconGoogleLoginLogo',{staticClass:"col-12"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }